import { render } from "./CustomButton.vue?vue&type=template&id=3e00be48&ts=true"
import script from "./CustomButton.vue?vue&type=script&lang=ts"
export * from "./CustomButton.vue?vue&type=script&lang=ts"

import "./CustomButton.vue?vue&type=style&index=0&id=3e00be48&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__